import { useLanguage } from "@/i18n/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t("marquee"), ...t("marquee")];
  return (
    <div
      data-testid="commodities-marquee"
      className="relative overflow-hidden border-y border-[#4a6cf7]/20 bg-[#0d223f] py-4"
    >
      <div className="flex w-max animate-osm-marquee items-center gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-xs sm:text-sm font-medium uppercase tracking-[0.3em] text-slate-300">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#4a6cf7]" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
